import type { FC } from "react";

import { SelectInputStyle } from "../../documentation/styles/InputStyle";
import type { FormInputProps } from "../Form/types/types";

export interface SelectInputProps extends FormInputProps<string> {
    placeholder?: string;
    isLoading?: boolean;
    onClick?: () => void;
    mode?: "multiple" | "tags";
    defaultValue?: string;
}

export const SelectInput: FC<SelectInputProps> = ({
    children,
    onClick,
    onChange,
    value,
    disabled,
    isLoading,
    defaultValue,
    ...restProps
}) => {
    const onValueChange = (newValue: string) => {
        if (onChange) {
            onChange(newValue);
        }
    };

    return (
        <SelectInputStyle
            className={disabled ? "aevi-input aevi-input-select aevi-select-disabled" : "aevi-input aevi-input-select"}
            showSearch
            disabled={disabled}
            defaultValue={defaultValue}
            allowClear
            loading={isLoading}
            value={value || null}
            // @ts-ignore
            onChange={onValueChange}
            onClick={onClick}
            optionFilterProp="children"
            {...restProps}
        >
            {children}
        </SelectInputStyle>
    );
};
